import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import * as Actions from "../../store/actions/contract/myContractDetailsActions";
import { TextWrapper, Wrapper } from "../../constants/common/StyledGlobalConstants";
import RadioCard from "./RadioCard";
import ContactMeForm from "./ContactMeForm";
import CPNotification from "../../pages/Login/CPNotification";
import DisplayingText from "./DisplayText";
import { CustomisedLabel, CountWrapper, ErrorBox, ErrorWrapper, CustomisedTextarea, CustomWrapper } from "./RequestDetails.styles";
import { useTranslation } from "react-i18next";
import RedesignedDropdown from "../common/RedesignedDropdown";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET, DESKTOP } = DEVICE_BREAKPOINTS;

const RequestDetails = (props) => {
  const { t } = useTranslation("contractsTranslation");
  const [dateToBeginValues, setDateToBeginValues] = useState([]);
  const [contactNameValues, setContactNameValues] = useState([]);
  const contactMeRef = useRef();
  const contactFormRef = useRef();
  let OtherOption = "Other";
  const reasonOptions = [
    "Business needs changed",
    "Concerns with my bill or contract",
    "Missing features I need",
    "Not sure how to use the data and tools",
    "Unsatisfactory customer support",
    "Sign-up experience didn’t meet expectations",
    "Technical issues",
    OtherOption,
  ];
  useEffect(() => {
    const getContactData = () => ([
      {
        name: "contractContact",
        label: t("Contact me"),
        value: "contactMe",
        ariaLabel: "Contact me",
        inputId: "contact-me",
        disabled: false,
      },
      {
        name: "contractContact",
        label: t("Contact someone else"),
        value: "contactSomeoneElse",
        ariaLabel: "Contact someone else",
        inputId: "contact-someone-else",
        disabled: false,
      },
    ]);
    const getDateToBeginData = () => {
      const data = [
      {
        name: "dateToBegin",
        label: t("Mid-service term"),
        children: "",
        value: "Mid-service term",
        ariaLabel: "Mid-service term",
        inputId: "mid-service-term",
        disabled: false,
      },
      {
        name: "dateToBegin",
        label: t("End of current service term"),
        children: "",
        value: "End of current service term",
        ariaLabel: "End of current service term",
        inputId: "end-of-current-service-term",
        disabled: false,
      },
    ];
    data[0].children = t(
      "The changes will be applied on the first or second billing cycle (but no more than 60 days) after the request has been processed. Certain changes may result in an early cancellation fee or other fee being charged to your account. See your contract for more details."
    );
    return data;
  };
    const updateContactForm = (data, contactType) => {
      if (contactType === "contactMe") {
        data[0].children = <ContactMeForm disabled={true} innerRef={contactFormRef} />;
        data[1].children = "";
      } else {
        data[0].children = ""; 
        data[1].children = <ContactMeForm disabled={false} innerRef={contactFormRef} />;
      }
      return data;
    };
    // Begin useEffect logic
    setDateToBeginValues(getDateToBeginData());
    let contactData = getContactData();
    if (props.contractContact) {
      contactData = updateContactForm(contactData, props.contractContact);
    } 
      setContactNameValues(contactData);
  }, [props.contractContact]);

  useEffect(() => {
    if (props.windowSize.width < DESKTOP && contactFormRef?.current) {
      contactFormRef.current.focus();
    }
  }, [props.contractContact, props.windowSize.width]);

  const reset = () => {
    props.setRequestContractDetails("contactName", "");
    props.setRequestContractDetails("contactEmailAddress", "");
    props.setRequestContractDetails("contactPhoneNumber", "");
  };

  const handleRadioChange = (name, value) => {
    props.setRequestContractDetails(name, value);
    if (name === "contractContact") {
      reset();
      if(props.windowSize.width < DESKTOP && contactMeRef?.current) {
        contactMeRef.current.focus();
      }
      updateContactForm(value);
    }
  };

  const updateContactForm =(value) => {
    const data = contactNameValues;
      if (value === "contactMe") {
          props.setRequestContractDetails("contactName", props.fullName);
          props.setRequestContractDetails("contactEmailAddress", props.accountEmailId);
          props.setRequestContractDetails("contactPhoneNumber", props.accountPhoneNumber);
          data[0].children = <ContactMeForm disabled={true} innerRef={contactFormRef} />;
          data[1].children = "";
      } else {
          data[1].children = <ContactMeForm disabled={false} innerRef={contactFormRef} />;
          data[0].children = "";
      }
        setContactNameValues(data)
  };

  const maxLength = 500;
  const [description, setDescription] = useState({
    status: props.reason === OtherOption ,
    error: props.reason === OtherOption && !props?.reasonDescription?.length,
    reasonDecs: props.reasonDescription || "",
  });

  const reasonDropdown = (value) => {
    const isOther = value === OtherOption;
      setDescription ({
        ...description,
        status: isOther,
        error: isOther,
        reasonDecs: "",
      });
  };

  const requestDetails = (details) => {
      const isOther = props.reason === OtherOption;
      if (details.length > 0){
        const trimmedDetails = details.length > maxLength ? details.slice(0, maxLength) : details;
        setDescription({
          ...description,
          error : false,
          reasonDecs: trimmedDetails,
        });
        props.setRequestContractDetails("reasonDescription", trimmedDetails);
      }else {
        setDescription({
          ...description,
          error : isOther,
          reasonDecs: "",
        });
         props.setRequestContractDetails("reasonDescription", "");
       }
     };

    useEffect(() => {
      const htmlElement = document.querySelector("html");
      if (htmlElement) {
        htmlElement.style.overflow = "hidden";
      }
      return () => {
        const htmlElement = document.querySelector("html");
        if (htmlElement) {
          htmlElement.style.overflow = "scroll";
        }
      };
    }, []);
     
  return (
    <Wrapper
      display="inline-flex"
      flexDirection="column"
      alignItems="flex-start"
      gap="4rem"
      marginTop={props.windowSize.width < DESKTOP ? "1.5rem" : "3rem"}
    >
      <CustomWrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1.5rem">
        <TextWrapper
          aria-label={t(props.contractDetailsType === "change" ? "Request changes to subscriptions" : "Request to cancel all subscriptions")}
          aria-level="1"
          fontFamily="neue-haas-grotesk-display"
          fontSize="2.5rem"
          fontWeight="700"
          lineHeight="3rem"
        >
          {t(props.contractDetailsType === "change" ? "Request changes to subscriptions" : "Request to cancel all subscriptions")}
        </TextWrapper>
        <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem">
          {t("After we've received this information, our team will contact you to complete the process.")}
        </TextWrapper>
        <CPNotification
          isOpen={props.isActiveCancellationError}
          notificationType="error"
          closeButton={false}
          width="auto"
          height="auto"
          message={t("There was an issue when submitting your information. Try again.")}
        >
          <TextWrapper fontSize="0.875rem">{t("There was an issue when submitting your information. Try again.")}</TextWrapper>
        </CPNotification>
      </CustomWrapper>
      <Wrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1.5rem">
        <TextWrapper
          aria-level="2"
          fontFamily="neue-haas-grotesk-display"
          fontSize="1.5rem"
          fontWeight="700"
          lineHeight="2rem"
        >
          {t(`When do you want the ${props.contractDetailsType === "change" ? "change" : "cancellation"} to take place?`)}
        </TextWrapper>
        <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem">
          {t(
            `${
              props.contractDetailsType === "change" ? "Service changes" : "Cancellations"
            } can be applied at the end of the next billing cycle or at the end of the contract term.`
          )}
        </TextWrapper>
        <Wrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1rem">
          <RadioCard
            id="date-to-begin-radio-button"
            ariaLabel={`When do you want the ${props.contractDetailsType} to take place?`}
            values={dateToBeginValues}
            handleChange={handleRadioChange}
            defaultValue={props.dateToBegin}
          ></RadioCard>
        </Wrapper>
      </Wrapper>
      <Wrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1.5rem" width="100%">
        <TextWrapper
          aria-level="2"
          fontFamily="neue-haas-grotesk-display"
          fontSize="1.5rem"
          fontWeight="700"
          lineHeight="2rem"
        >
          {
            t(`Who should we contact about this ${props.contractDetailsType === "change" ? "change" : "cancellation"}?`)
            /* t(props.contractDetailsType === 'change' ? "Who should we contact about this change?" :
            `Who should we contact about this cancellation?`) */
          }
        </TextWrapper>
        <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" ref={contactMeRef}>
          {t(
            `Verizon Connect can only accept ${
              props.contractDetailsType === "change" ? "change" : "cancellation"
            } requests from an authorized customer representative.`
          )}
          {``}
        </TextWrapper>
        <Wrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1rem" width="100%">
          <RadioCard
            id="contact-name-radio-button"
            ariaLabel={`Who should we contact about this ${props.contractDetailsType}?`}
            values={contactNameValues}
            handleChange={handleRadioChange}
            defaultValue={props.contractContact}
          ></RadioCard>
        </Wrapper>
      </Wrapper>
      <Wrapper
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="1.5rem"
        width="100%"
        marginBottom="7em"
        style={{ paddingBottom: props.windowSize.width < DESKTOP ? "5em" : "" }}
      >
        <TextWrapper
          aria-level="2"
          fontFamily="neue-haas-grotesk-display"
          fontSize="1.5rem"
          fontWeight="700"
          lineHeight="2rem"
        >
          {t("Why do you want to make this change?")}
        </TextWrapper>
        <span className="sr-only">Select the main reason for changing your subscriptions and provide more details in the Description box.</span>
        <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" aria-hidden="true">
          <DisplayingText wordChange={props.contractDetailsType} />
        </TextWrapper>
        <Wrapper width="100%" gap="1.5rem" display="flex" flexDirection="column">
          <Wrapper width={props.windowSize.width < TABLET ? "100%" : "55%"}>
            <RedesignedDropdown
              id="my-contract-reason"
              label={t("Reason")}
              isRequired={true}
              ariaLabel="Reason"
              error={props.reasonErr}
              errorText={t("Please select a reason")}
              handleOnSelect={(value) => {
                reasonDropdown(value);
                props.setRequestContractDetails("reason", value);
                props.setRequestContractDetails("reasonDescription", "");
              }}
              value={props.reason ? props.reason : t("Select option")}
              disabled={false}
              optionList={reasonOptions}
              firstOption={t("Select option")}
              t={t}
            ></RedesignedDropdown>
          </Wrapper>
          {props.reason !== "" && (
            <Wrapper display="flex" flexDirection="column" fontFamily={"neue-haas-grotesk-text"} width="100%">
              <CustomisedLabel required={description.status}>
                {t("Description")}
                {!description.status && <>&nbsp;{t("(optional)")}</>}
              </CustomisedLabel>

              <CustomisedTextarea
                id="my-contract-reason-description"
                value={description.reasonDecs}
                onChange={(e) => {
                  requestDetails(e.target.value);
                }}
                cols={30}
                maxLength={maxLength}
                required={description.error}
                aria-label="Description"
              />
              <ErrorBox flexDirection="Column">
                {description.error && <ErrorWrapper role="alert" tabIndex="-1" aria-live="assertive">{t("Description is required")}</ErrorWrapper>}
                <CountWrapper>
                  {props?.reasonDescription ? props?.reasonDescription?.length : 0}/{maxLength}
                </CountWrapper>
              </ErrorBox>
            </Wrapper>
          )}
        </Wrapper>
      </Wrapper>
    </Wrapper>
  );
};

const mapDispatchToProps = {
  setRequestContractDetails: Actions.setRequestContractDetails,
  setContractFormDetailsError: Actions.setContractFormDetailsError,
};

const mapStateToProps = (state) => {
  return {
    contractDetailsType: state.CONTRACT.contractDetailsType,
    windowSize: state.ACCOUNT.windowSize,
    fullName: state.ACCOUNT.fullName,
    accountEmailId: state.CONTRACT.accountEmailId,
    accountPhoneNumber: state.CONTRACT.accountPhoneNumber,
    dateToBegin: state.CONTRACT.dateToBegin,
    reason: state.CONTRACT.reason,
    reasonDescription: state.CONTRACT.reasonDescription,
    contractContact: state.CONTRACT.contractContact,
    isActiveCancellationError: state.CONTRACT.isActiveCancellationError,
    userLanguage: state.ACCOUNT.userLanguage,
    regionId: state.ACCOUNT.accountUserTokenDetails.accountRegionId,
  };
};

RequestDetails.propTypes = {
  contractContact: PropTypes.string,
  fullName: PropTypes.string,
  accountEmailId: PropTypes.string,
  accountPhoneNumber: PropTypes.string,
  reason: PropTypes.string,
  reasonDescription: PropTypes.string,
  reasonErr: PropTypes.bool,
  dateToBegin: PropTypes.string,
  setRequestContractDetails: PropTypes.func.isRequired,
  windowSize: PropTypes.shape({
    width: PropTypes.number,
  }),
  contractDetailsType: PropTypes.string,
  isActiveCancellationError: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestDetails);